<script>
    import TagDisplay from '../../Tag/TagDisplay.svelte';

    export let row = {};
</script>

<TagDisplay tags={row.tags} />